export default __webpack_public_path__ + "static/media/switchToOwner.498ee2d6.svg";